<script>
import Vue from 'vue/dist/vue.common.js';
import VeeValidate from 'vee-validate';
import Icon from './icon';

Vue.use(VeeValidate);
import EventBus from '../instances/event-bus';
import IssueSubmissionsService from '../services/issue-submissions';

export default {
  components: {
    Icon
  },
  props: {
    personId: { required: true }
  },
  data() {
    return {
      issueSubmission: {
        notes: '',
        declineToProsecuteNonViolentCrimesStatus: 'unknown',
        endCashBailStatus: 'unknown',
        treatKidsLikeKidsStatus: 'unknown',
        considerImmigrationConsequencesStatus: 'unknown',
        beTransparentAndAccountableStatus: 'unknown',
        holdPoliceAccountableStatus: 'unknown'
      },
      options: {
        'unknown': 'Unknown',
        'mostly_yes': 'Mostly Yes',
        'leans_yes': 'Making Progress',
        'leans_no': 'No Progress',
        'mostly_no': 'Mostly No'
      },
      posting: false,
      submitted: false
    }
  },
  computed: {
    valid () {
      const self = this;
      if ( self.fields.notes.valid ) {
        return true;
      }
      return false;
    },
  },
  methods: {
    cancel() {
      EventBus.$emit('closeModal');
    },
    submit() {
      const self = this;
      self.posting = true;
      IssueSubmissionsService.create(
        self.personId,
        self.issueSubmission.notes,
        self.issueSubmission.declineToProsecuteNonViolentCrimesStatus,
        self.issueSubmission.endCashBailStatus,
        self.issueSubmission.treatKidsLikeKidsStatus,
        self.issueSubmission.considerImmigrationConsequencesStatus,
        self.issueSubmission.beTransparentAndAccountableStatus,
        self.issueSubmission.holdPoliceAccountableStatus
      ).then(
        response => {
          self.posting = false;
        }
      );
      self.submitted = true;
    }
  }
}
</script>

<template lang="html">
  <form class="u-form u-form--light" @submit.prevent="submit">
    <div v-if="!submitted">

      <div class="u-mb2">
        <label for="issue-submission-notes">
          Notes
          <span data-error v-show="errors.has('notes')">{{ errors.first('notes') }}</span>
        </label>

        <textarea id="issue-submission-notes" placeholder="" rows="5" name="notes" v-model="issueSubmission.notes" v-validate="{required: true}"/>
      </div>

      <fieldset>
        <legend class="u-mb2">Does this person meet the Prosecutor Project standard on these five issues?</legend>

        <div class="u-mb2">
          <label for="issue-submission-status-1">Stop Unnecessary Prosecutions</label>
          <div class="js-custom-select u-form-shortWrapper">
            <select v-model="issueSubmission.declineToProsecuteNonViolentCrimesStatus" id="issue-submission-status-1">
              <option v-for="(option, key) in options" :value="key">{{ option }}</option>
            </select>
            <icon icon="arrow-down"></icon>
          </div>
        </div>

        <div class="u-mb2">
          <label for="issue-submission-status-2">End Money Bail</label>
          <div class="js-custom-select u-form-shortWrapper">
            <select v-model="issueSubmission.endCashBailStatus" id="issue-submission-status-2">
              <option v-for="(option, key) in options" :value="key">{{ option }}</option>
            </select>
            <icon icon="arrow-down"></icon>
          </div>
        </div>

        <div class="u-mb2">
          <label for="issue-submission-status-3">Treat Kids Like Kids</label>
          <div class="js-custom-select u-form-shortWrapper">
            <select v-model="issueSubmission.treatKidsLikeKidsStatus" id="issue-submission-status-3">
              <option v-for="(option, key) in options" :value="key">{{ option }}</option>
            </select>
            <icon icon="arrow-down"></icon>
          </div>
        </div>

        <div class="u-mb2">
          <label for="issue-submission-status-4">Stop Anti-Immigration Prosecutions</label>
          <div class="js-custom-select u-form-shortWrapper">
            <select v-model="issueSubmission.considerImmigrationConsequencesStatus" id="issue-submission-status-4">
              <option v-for="(option, key) in options" :value="key">{{ option }}</option>
            </select>
            <icon icon="arrow-down"></icon>
          </div>
        </div>

        <div class="u-mb2">
          <label for="issue-submission-status-5">End the Secrecy</label>
          <div class="js-custom-select u-form-shortWrapper">
            <select v-model="issueSubmission.beTransparentAndAccountableStatus" id="issue-submission-status-5">
              <option v-for="(option, key) in options" :value="key">{{ option }}</option>
            </select>
            <icon icon="arrow-down"></icon>
          </div>
        </div>

        <div class="u-mb2">
          <label for="issue-submission-status-6">Hold Police Accountable</label>
          <div class="js-custom-select u-form-shortWrapper">
            <select v-model="issueSubmission.holdPoliceAccountableStatus" id="issue-submission-status-6">
              <option v-for="(option, key) in options" :value="key">{{ option }}</option>
            </select>
            <icon icon="arrow-down"></icon>
          </div>
        </div>

      </fieldset>

      <div class="u-form-actions u-mt4">
        <button v-bind:disabled="posting" type="submit" class="Button Button--square">
          Submit
        </button>
        <button @click="cancel" type="button" class="Button Button--outline">
          Cancel
        </button>
      </div>
    </div>

    <div v-else>
      <p class="u-mb2">Thank you for providing this information and for helping us hold prosecutors across the nation accountable to the communities they serve.</p>
      <p class="u-mb4">We will review your submission and update our directory once it is approved.</p>
      <button @click="cancel" type="button" class="Button Button--square">
        Close
      </button>
    </div>
  </form>
</template>



// WEBPACK FOOTER //
// accountability-form.vue?397418ec